import List from './List.vue';

export default List;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/components/list/index.ts